"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/default-props-match-prop-types */
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const lodash_isfunction_1 = __importDefault(require("lodash.isfunction"));
const lodash_isobject_1 = __importDefault(require("lodash.isobject"));
const oxygen_config_1 = require("@8x8/oxygen-config");
const types_1 = require("../constants/types");
const themeName_1 = require("../constants/themeName");
const InputIcon_1 = __importDefault(require("../styled/InputIcon"));
const InputField_1 = __importDefault(require("../styled/InputField"));
const InputWrapper_1 = __importDefault(require("../styled/InputWrapper"));
const InputDecorator_1 = __importDefault(require("../styled/InputDecorator"));
const InputFieldWrapper_1 = __importDefault(require("../styled/InputFieldWrapper"));
class Input extends react_1.PureComponent {
    constructor(props) {
        super(props);
        this.state = { focused: false };
        this.setInputFieldRef = (element) => {
            const { inputRef } = this.props;
            this.inputFieldRef.current = element;
            if ((0, lodash_isfunction_1.default)(inputRef)) {
                inputRef(element);
            }
            if ((0, lodash_isobject_1.default)(inputRef)) {
                inputRef.current = element;
            }
        };
        this.handleFocus = (event) => {
            this.setState({ focused: true });
            this.props.onFocus?.(event);
        };
        this.handleBlur = (event) => {
            this.setState({ focused: false });
            this.props.onBlur?.(event);
        };
        this.inputFieldRef = { current: null };
    }
    componentDidMount() {
        if (this.props.focus && this.inputFieldRef) {
            this.inputFieldRef.current?.focus();
        }
    }
    render() {
        const { id, name, value, max, min, maxLength, placeholder, type, autoComplete, autoFocus, size, prefix, suffix, iconLeft: IconLeft, iconRight: IconRight, fixed, hasError, isDisabled, isReadOnly, isRequired, fullWidth, onKeyUp, onKeyDown, onChange, onFocus, onBlur, forwardedRef, autoPrefixWidth, autoSuffixWidth, inputProps, theme: themeProp, ...otherProps } = this.props;
        const theme = themeProp; // theme is full theme object as injected by withTheme
        const { testId } = this.props;
        const { focused } = this.state;
        const isValuePresent = Boolean(value);
        return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme },
            react_1.default.createElement(InputWrapper_1.default, { ...(0, oxygen_config_1.getTestAttributes)(testId), ref: forwardedRef, size: size, isDisabled: isDisabled, isReadOnly: isReadOnly, fixed: fixed, fullWidth: fullWidth, ...otherProps },
                prefix && !theme.prefixSuffixInsideInput && (react_1.default.createElement(InputDecorator_1.default, { focused: focused, hasError: hasError, isReadOnly: isReadOnly, autoWidth: autoPrefixWidth, isPrefix: !!prefix },
                    react_1.default.createElement("span", null, prefix))),
                react_1.default.createElement(InputFieldWrapper_1.default, { isDisabled: isDisabled, withPrefix: !!prefix, withSuffix: !!suffix, fixed: fixed, isReadOnly: isReadOnly, focused: focused, hasError: hasError, iconLeft: !!IconLeft, iconRight: !!IconRight },
                    prefix && theme.prefixSuffixInsideInput && (react_1.default.createElement(InputDecorator_1.default, { focused: focused, hasError: hasError, isReadOnly: isReadOnly, autoWidth: autoPrefixWidth, isPrefix: !!prefix },
                        react_1.default.createElement("span", null, prefix))),
                    IconLeft && (react_1.default.createElement(InputIcon_1.default, null,
                        react_1.default.createElement(IconLeft, { size: theme.iconSize, color: !isValuePresent ? theme.colorPlaceholder : theme.colorIcon }))),
                    react_1.default.createElement(InputField_1.default, { ref: this.setInputFieldRef, id: id, max: max, min: min, maxLength: maxLength, "aria-disabled": isDisabled, "aria-invalid": hasError, "aria-required": isRequired, "aria-readonly": isReadOnly || isDisabled, name: name, type: type, autoComplete: autoComplete, autoFocus: autoFocus, value: value, placeholder: placeholder, fixed: fixed, readOnly: isReadOnly || isDisabled, isDisabled: Boolean(fixed) || Boolean(isDisabled), onKeyUp: onKeyUp, onKeyDown: onKeyDown, onChange: onChange, ...inputProps, onBlur: this.handleBlur, onFocus: this.handleFocus, ...(0, oxygen_config_1.getTestAttributes)(`${testId}_FIELD`) }),
                    IconRight && (react_1.default.createElement(InputIcon_1.default, null,
                        react_1.default.createElement(IconRight, { size: theme.iconSize, color: !isValuePresent ? theme.colorPlaceholder : theme.colorIcon }))),
                    suffix && theme.prefixSuffixInsideInput && (react_1.default.createElement(InputDecorator_1.default, { autoWidth: autoSuffixWidth, focused: focused, hasError: hasError, isSuffix: !!suffix, isReadOnly: isReadOnly },
                        react_1.default.createElement("span", null, suffix)))),
                suffix && !theme.prefixSuffixInsideInput && (react_1.default.createElement(InputDecorator_1.default, { autoWidth: autoSuffixWidth, focused: focused, hasError: hasError, isSuffix: !!suffix, isReadOnly: isReadOnly },
                    react_1.default.createElement("span", null, suffix))))));
    }
}
Input.defaultProps = {
    autoFocus: false,
    autoPrefixWidth: false,
    autoSuffixWidth: false,
    fixed: false,
    focus: false,
    fullWidth: true,
    hasError: false,
    isDisabled: false,
    isReadOnly: false,
    isRequired: false,
    placeholder: '',
    prefix: '',
    size: 'default',
    suffix: '',
    testId: 'INPUT',
    type: types_1.TEXT,
};
exports.default = (0, oxygen_config_1.withTheme)(Input, themeName_1.THEME_NAME);
